/*
Copyright 2015, 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _matrixJsSdk = require('matrix-js-sdk');

var _Keyboard = require('../../Keyboard');

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _VectorConferenceHandler = require('../../VectorConferenceHandler');

var _VectorConferenceHandler2 = _interopRequireDefault(_VectorConferenceHandler);

var _TagPanelButtons = require('./TagPanelButtons');

var _TagPanelButtons2 = _interopRequireDefault(_TagPanelButtons);

var _SettingsStore = require('../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftPanel = _react2.default.createClass({
    displayName: 'LeftPanel',

    // NB. If you add props, don't forget to update
    // shouldComponentUpdate!
    propTypes: {
        collapsed: _propTypes2.default.bool.isRequired
    },

    contextTypes: {
        matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient)
    },

    getInitialState: function getInitialState() {
        return {
            searchFilter: ''
        };
    },

    componentWillMount: function componentWillMount() {
        this.focusedElement = null;
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        // MatrixChat will update whenever the user switches
        // rooms, but propagating this change all the way down
        // the react tree is quite slow, so we cut this off
        // here. The RoomTiles listen for the room change
        // events themselves to know when to update.
        // We just need to update if any of these things change.
        if (this.props.collapsed !== nextProps.collapsed || this.props.disabled !== nextProps.disabled) {
            return true;
        }

        if (this.state.searchFilter !== nextState.searchFilter) {
            return true;
        }

        return false;
    },

    _onFocus: function _onFocus(ev) {
        this.focusedElement = ev.target;
    },

    _onBlur: function _onBlur(ev) {
        this.focusedElement = null;
    },

    _onKeyDown: function _onKeyDown(ev) {
        if (!this.focusedElement) return;
        var handled = true;

        switch (ev.keyCode) {
            case _Keyboard.KeyCode.TAB:
                this._onMoveFocus(ev.shiftKey);
                break;
            case _Keyboard.KeyCode.UP:
                this._onMoveFocus(true);
                break;
            case _Keyboard.KeyCode.DOWN:
                this._onMoveFocus(false);
                break;
            case _Keyboard.KeyCode.ENTER:
                this._onMoveFocus(false);
                if (this.focusedElement) {
                    this.focusedElement.click();
                }
                break;
            default:
                handled = false;
        }

        if (handled) {
            ev.stopPropagation();
            ev.preventDefault();
        }
    },

    _onMoveFocus: function _onMoveFocus(up) {
        var element = this.focusedElement;

        // unclear why this isn't needed
        // var descending = (up == this.focusDirection) ? this.focusDescending : !this.focusDescending;
        // this.focusDirection = up;

        var descending = false; // are we currently descending or ascending through the DOM tree?
        var classes = void 0;

        do {
            var child = up ? element.lastElementChild : element.firstElementChild;
            var sibling = up ? element.previousElementSibling : element.nextElementSibling;

            if (descending) {
                if (child) {
                    element = child;
                } else if (sibling) {
                    element = sibling;
                } else {
                    descending = false;
                    element = element.parentElement;
                }
            } else {
                if (sibling) {
                    element = sibling;
                    descending = true;
                } else {
                    element = element.parentElement;
                }
            }

            if (element) {
                classes = element.classList;
                if (classes.contains("mx_LeftPanel")) {
                    // we hit the top
                    element = up ? element.lastElementChild : element.firstElementChild;
                    descending = true;
                }
            }
        } while (element && !(classes.contains("mx_RoomTile") || classes.contains("mx_textinput_search")));

        if (element) {
            element.focus();
            this.focusedElement = element;
            this.focusedDescending = descending;
        }
    },

    onHideClick: function onHideClick() {
        _dispatcher2.default.dispatch({
            action: 'hide_left_panel'
        });
    },

    onSearch: function onSearch(term) {
        this.setState({ searchFilter: term });
    },

    onSearchCleared: function onSearchCleared(source) {
        if (source === "keyboard") {
            _dispatcher2.default.dispatch({ action: 'focus_composer' });
        }
    },

    collectRoomList: function collectRoomList(ref) {
        this._roomList = ref;
    },

    render: function render() {
        var RoomList = _index2.default.getComponent('rooms.RoomList');
        var RoomBreadcrumbs = _index2.default.getComponent('rooms.RoomBreadcrumbs');
        var TagPanel = _index2.default.getComponent('structures.TagPanel');
        var CustomRoomTagPanel = _index2.default.getComponent('structures.CustomRoomTagPanel');
        var TopLeftMenuButton = _index2.default.getComponent('structures.TopLeftMenuButton');
        var SearchBox = _index2.default.getComponent('structures.SearchBox');
        var CallPreview = _index2.default.getComponent('voip.CallPreview');

        var tagPanelEnabled = _SettingsStore2.default.getValue("TagPanel.enableTagPanel");
        var tagPanelContainer = void 0;

        var isCustomTagsEnabled = _SettingsStore2.default.isFeatureEnabled("feature_custom_tags");

        if (tagPanelEnabled) {
            tagPanelContainer = _react2.default.createElement(
                'div',
                { className: 'mx_LeftPanel_tagPanelContainer' },
                _react2.default.createElement(TagPanel, null),
                isCustomTagsEnabled ? _react2.default.createElement(CustomRoomTagPanel, null) : undefined,
                _react2.default.createElement(_TagPanelButtons2.default, null)
            );
        }

        var containerClasses = (0, _classnames2.default)("mx_LeftPanel_container", "mx_fadable", {
            "collapsed": this.props.collapsed,
            "mx_LeftPanel_container_hasTagPanel": tagPanelEnabled,
            "mx_fadable_faded": this.props.disabled
        });

        var searchBox = _react2.default.createElement(SearchBox, {
            onSearch: this.onSearch,
            onCleared: this.onSearchCleared,
            collapsed: this.props.collapsed });

        var breadcrumbs = void 0;
        if (_SettingsStore2.default.isFeatureEnabled("feature_room_breadcrumbs")) {
            breadcrumbs = _react2.default.createElement(RoomBreadcrumbs, { collapsed: this.props.collapsed });
        }

        return _react2.default.createElement(
            'div',
            { className: containerClasses },
            tagPanelContainer,
            _react2.default.createElement(
                'aside',
                { className: "mx_LeftPanel dark-panel", onKeyDown: this._onKeyDown, onFocus: this._onFocus, onBlur: this._onBlur },
                _react2.default.createElement(TopLeftMenuButton, { collapsed: this.props.collapsed }),
                breadcrumbs,
                searchBox,
                _react2.default.createElement(CallPreview, { ConferenceHandler: _VectorConferenceHandler2.default }),
                _react2.default.createElement(RoomList, {
                    ref: this.collectRoomList,
                    toolbarShown: this.props.toolbarShown,
                    collapsed: this.props.collapsed,
                    searchFilter: this.state.searchFilter,
                    ConferenceHandler: _VectorConferenceHandler2.default })
            )
        );
        // <BottomLeftMenu collapsed={this.props.collapsed}/>
    }
});

module.exports = LeftPanel;
//# sourceMappingURL=LeftPanel.js.map